import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand",
  "use": "icon-expand-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol viewBox=\"0 0 18 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-expand\">\r\n<path d=\"M0.8975 0.0274996H5.43V1.55H2.595V14.85H5.43V16.3725H0.8975V0.0274996ZM12.5528 0.0274996H17.0853V16.3725H12.5528V14.85H15.3878V1.55H12.5528V0.0274996Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol